/**
 * Pre-login password hashing for arcano.app
 * This code is under copyright Arcano Gmbh (https://arcano.app).
 *
 * - no commercial use
 * - no modifications
 * - no redistribution
 *
 * without written consent of Arcano Gmbh, zentralstrasse 47, 8003 zürich, switzerland, https://arcano.app
*/
import {generateScryptHash, sendEditedFormData} from "./crypto";

export function setupDeleteAccount() {
    const form = document.getElementById('deleteForm') as HTMLFormElement;
    if(!form) {
        return;
    }
    form.addEventListener('submit', async (event) => {
        event.preventDefault();

        const password = document.getElementById('password') as HTMLInputElement;
        if (password.value) {

            const prelogin = await fetch('/pre_login').then((response) => response.json())
            const currentPasswordValue = new TextEncoder().encode(password.value);
            const currentPasswordData = await generateScryptHash(currentPasswordValue, prelogin.hkdfSalt, prelogin.scryptSalt)

            let data = new FormData(form);
            data.set('password', currentPasswordData.scryptHashedPassword);  // todo test on all browsers
            sendEditedFormData(form.action, data);

        } else {
            console.debug('Nevermind');
        }
    });
}